import React from 'react'
import styled from 'styled-components'
import { FaTimes } from "react-icons/fa";
import { FontSize3, FontSize9 } from '../../GlobalStyles';
import Chart from '../../assets/images/detail/size_chart.jpeg'

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: ${({show}) => show ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    z-index: 2;
`
const Box = styled.div`
    width: 80%;
    max-width: 700px;
    height: 40vh;
    position: relative;
    margin-top: -3rem;
    font-size: ${FontSize3};
    background-color: white;
    padding: 1rem;
    display: grid;
    grid-template-rows: auto 1fr;
    @media (min-width: 550px) {
        height: 50vh;
    }
    @media (min-width: 650px) {
        height: 55vh;
    }
    @media (min-width: 750px) {
        height: 60vh;
    }
    @media (min-width: 850px) {
        height: 65vh;
    }
    svg {
        font-size: ${FontSize9};
        position: absolute;
        top: 1rem;
        right: 1rem;
        color: black;
        cursor: pointer;
    }
`
const ChartImg = styled.div`
    background-image: url(${({bgImg}) => bgImg});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
`
export default function Modal({ show, modalToggle }) {
  return (
    <Container show={show}>
        <Box>
            <FaTimes onClick={modalToggle} />
            <h4>Size Chart</h4>
            <ChartImg bgImg={Chart} />
        </Box>
    </Container>
  )
}
